import { render, staticRenderFns } from "./singleCustomer.vue?vue&type=template&id=33f83391&scoped=true&"
import script from "./singleCustomer.vue?vue&type=script&lang=js&"
export * from "./singleCustomer.vue?vue&type=script&lang=js&"
import style0 from "./singleCustomer.vue?vue&type=style&index=0&id=33f83391&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f83391",
  null
  
)

export default component.exports